export default "__VITE_ASSET__BY2Lhtr6__"